import { useContext, useEffect, useState } from 'react';
import { ResidualValues } from '../sections/ResidualValues';
import { AuthContext } from '../../../Context/AuthContext';
import { functionGetResidualValues } from '../functions/functionsFetch';
import { useAdminToast } from '../shell/AdminToastContext';

export const ValoresResidualesPage = () => {
    const toast = useAdminToast();
    const { logout } = useContext(AuthContext);
    const [residualValsRes, setResidualValsRes] = useState([]);

    useEffect(() => {
        let active = true;
        (async () => {
            try {
                const result0 = await functionGetResidualValues(logout);
                if (active) setResidualValsRes(result0);
            } catch (error) {
                console.log(error);
            }
        })();
        return () => {
            active = false;
        };
    }, [logout]);

    return (
        <ResidualValues
            residualValsRes={residualValsRes}
            setResidualValsRes={setResidualValsRes}
            toast={toast}
        />
    );
};

export default ValoresResidualesPage;
